export default __webpack_public_path__ + "static/services-details1h-532d55fa6167a5cc8def751c6e46fed0.jpg";